module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }